import e from './style.module.css';
import UnderConstrution from 'assets/img/work-in-progress.png';

export const Reclamaciones = () => {
  return (
    <div className='container row d-flex justify-content-center my-5 py-5'>
      <div className='col-md-8 col-lg-5'>
        <img src={UnderConstrution} className={`center ${e.img_constru}`} alt='Pagina en construccion imagen' />
      </div>
      
    </div>
    
  )
}
